import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Button, Typography, Box } from '@mui/material';
import { ReactComponent as SuccessIcon } from '../../img/success.svg';
import { ReactComponent as SuccessIconWhite } from '../../img/success-white.svg';
import { REACT_APP_SSO_KEY } from '../../localStorageKeys';
import { ApiContext } from '../../context/ApiContext';
import { UIContext } from '../../context/UIContext';
import usePageTitle from '../../helperHooks/usePageTitle';

const Confirmation = () => {
  const { t } = useTranslation();
  const { colorMode } = useContext(UIContext);
  const { verificationCode, username } = useContext(ApiContext);

  usePageTitle('nav.confirmation');

  return (
    <Card
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
        alignItems: 'center',
      }}
    >
      {colorMode === 'light' ? <SuccessIcon /> : <SuccessIconWhite />}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', marginTop: '2rem' }}>
        <Typography variant="h3">{t('screens.confirmation.header')}</Typography>
        <Typography variant="body1" sx={{ marginTop: '0.5rem', color: 'text.secondary' }}>
          {t('screens.confirmation.description1')}
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          {t('screens.confirmation.description2')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, marginTop: '1rem', color: 'text.secondary' }}
        >
          {t('screens.confirmation.description3')}
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          {t('screens.confirmation.description4')}
        </Typography>
        <Typography variant="body1" sx={{ marginTop: '0.5rem', color: 'text.secondary' }}>
          {t('screens.confirmation.description5')}
        </Typography>
        <Button
          variant="contained"
          component="a"
          href={
            verificationCode && username
              ? `${localStorage.getItem(
                  REACT_APP_SSO_KEY
                )}v2/reset-password?code=${verificationCode}&username=${username}`
              : `${localStorage.getItem(REACT_APP_SSO_KEY)}v2/reset-password`
          }
          sx={{ marginTop: '2em' }}
        >
          {t('screens.confirmation.button')}
        </Button>
      </Box>
    </Card>
  );
};

export default Confirmation;
